import axios from './axios'
export  function saveInfo(name,phone,net_num,code) {
    return axios.post('/src/send.php',{

        name:name,
        phone:phone,
        net_num:net_num,
        code:code

    })
}
export function getCode(phone) {
    return axios.get('/src/phone.php',{
        params: {
            phone
        }
    })

}

